import { search } from "../../assets/js/api.js";
import * as Helpers from "@/helpers/index.js"
import axios from 'axios';

export default {
  //namespaced: true,
  state: {
    fieldsAbs: [],
    fieldsRel: [],
    items: [],
    loading: false,
    uniSize: "",
    resultCount: "",
    panelDay: "",
    showToastError: false,
    cancelTokenSource: null,
  },
  getters: {
    fieldsAbs: state => state.fieldsAbs,
    fieldsRel: state => state.fieldsRel,
    items: state => state.items,
    loading: state => state.loading,
    uniSize: state => state.uniSize,
    resultCount: state => state.resultCount,
    panelDay: state => state.panelDay
  },
  mutations: {
    setFieldsAbs: (state, payload) => state.fieldsAbs = payload,
    setFieldsRel: (state, payload) => state.fieldsRel = payload,
    setItems: (state, payload) => state.items = payload,
    setLoading: (state, payload) => state.loading = payload,
    setUniSize: (state, payload) => state.uniSize = payload,
    setResultCount: (state, payload) => state.resultCount = payload,
    setPanelDay: (state, payload) => state.panelDay = payload,
    setShowToastError: (state, payload) => state.showToastError = payload,
    setState: (state, payload) => Object.assign(state, payload),
    setCancelTokenSource: (state, source) => state.cancelTokenSource = source,
  },
  actions: {
    resetReachState: context => { 
      context.commit("setState", {
        fieldsAbs: [],
        fieldsRel: [],
        items: [],
        loading: false,
        uniSize: "",
        resultCount: "",
        panelDay: "",
        showToastError: false
      });
      if (context.state.cancelTokenSource) {
        context.state.cancelTokenSource.cancel('Resetting program state');
        context.commit('setCancelTokenSource', null);
      }
    },
    searchReach: context => {
      if (context.state.cancelTokenSource) {
        context.state.cancelTokenSource.cancel('New request initiated');
      }
      const cancelToken = axios.CancelToken.source();
      context.commit('setCancelTokenSource', cancelToken);

      context.commit("setItems", []);
      context.commit("setFieldsAbs", []);
      context.commit("setFieldsRel", []);
      let minViewingTime = context.getters["reachForm/getSelectedReachObj"].selected;
      let measureType = context.getters["reachForm/getSelectedMeasureType"];
    
      let measures = context.getters["reachApiBody/reachApiBody"].measures.map(obj => {
        return {
          consolidation_days: obj.consolidation_days,
          measure_type: measureType,
          min_viewing_time: minViewingTime,
          target_group_keys: obj.target_group_keys,
          genderAndAge: obj.genderAndAge
        };
      });
      let uniqueMeasures = measures.filter((value, index) => {
        const _value = JSON.stringify(value);
        return index === measures.findIndex(obj => {
          return JSON.stringify(obj) === _value;
        });
      });
      
      let reachApiBody = context.getters["reachApiBody/reachApiBody"];
      if(reachApiBody.selectedPeriod == 'publicationperiod')
        uniqueMeasures = uniqueMeasures.filter(m => m.consolidation_days !== -1)
      else
        uniqueMeasures = uniqueMeasures.filter(m => m.consolidation_days === -1)

      // Has measures for selected period?
      if (uniqueMeasures == null || uniqueMeasures.length === 0) {
        return;
      }
      context.commit("setLoading", true);
      reachApiBody.measures = uniqueMeasures;
      // eslint-disable-next-line no-console
      search("QueryReachData", { payload: reachApiBody }, cancelToken.token)
        .then(response => {
          if (response.statusCode) {    
            context.commit("setShowToastError", true);
          }
          if (response.data && response.info) {
            context.commit(
              "setUniSize",
              Helpers.formatNumberWithThousandSeparator(response.info.total_universe_size)
            );
            context.commit(
              "setResultCount",
              Helpers.formatNumberWithThousandSeparator(response.info.total_row_count)
            );
            context.commit(
              "setPanelDay",
              response.info.panel_day.substring(0, 10)
            );

            response.data.forEach(element => {
              if (element.date_key != null) {
                element.date_key = element.date_key.substring(0, 10);
                element.date_key_rel = element.date_key.substring(0, 10);
              }
            });
            let firstField = { key: "date_key", label: "", thClass: "firstThRofClass" };
            let firstFieldRel = { key: "date_key_rel", label: "", thClass: "firstThRofClass" };
            let updatedFieldsAbs = [...context.getters.fieldsAbs, firstField];
            context.commit("setFieldsAbs", updatedFieldsAbs);
            let updatedFieldsRel = [...context.getters.fieldsRel, firstFieldRel];
            context.commit("setFieldsRel", updatedFieldsRel);

            let firstRowAndCellText = { date_key: "Net Reach 1+ indv", date_key_rel: "Net Reach 1+ %" };
            let secondRowAndFirstCellText = { date_key: "Avg Freq", date_key_rel: "Avg Freq"  };
            let universeSize = { date_key: "Universe size indv", date_key_rel: "Universe size indv" };
            let emptyRow = { date_key: "" };

            let newTargetGroups  = [];
            for (let i = 0; i < measures.length; i++) {
              if (reachApiBody.selectedPeriod == 'publicationperiod') {
                if (measures[i].consolidation_days != -1) {
                  newTargetGroups.push(
                    {
                      reachAbsHeader: `Reach indv ${measures[i].genderAndAge}`,
                      reachRelHeader: `Reach % ${measures[i].genderAndAge}`
                    }
                  ) 
                }
              }
              else {
                if (measures[i].consolidation_days == -1) {
                  newTargetGroups.push(
                    {
                      reachAbsHeader: `Reach indv ${measures[i].genderAndAge}`,
                      reachRelHeader: `Reach % ${measures[i].genderAndAge}`
                    }
                  ) 
                }
              }
              
            }
            let campaignSelectedReachObj = { ...context.getters["reachForm/getSelectedReachObj"] };
            let selectedReachCriteriaText = campaignSelectedReachObj.options.filter(function(reachCriteria) {
              if (reachCriteria.value === this) return reachCriteria;
            }, campaignSelectedReachObj.selected)[0].selectedReachCriteriaText;
            for (let i = 0; i < response.summary.length; i++) {
              let field = {
                key: response.summary[i].measure,
                label:
                `${newTargetGroups[i].reachAbsHeader}, ${selectedReachCriteriaText}`
              };
              updatedFieldsAbs = [...context.getters.fieldsAbs, field];
              context.commit("setFieldsAbs", updatedFieldsAbs);

              let fieldRel = {
                key: response.summary[i].measure + "_rel",
                label:
                `${newTargetGroups[i].reachRelHeader}, ${selectedReachCriteriaText}`
              };
              updatedFieldsRel = [...context.getters.fieldsRel, fieldRel];
              context.commit("setFieldsRel", updatedFieldsRel);
              let firstRowAndCellValue =
                response.summary[i].total_reach == -1
                  ? "n/a"
                  : Helpers.formatNumberWithThousandSeparator(Math.round(response.summary[i].total_reach));
              firstRowAndCellText[response.summary[i].measure] = firstRowAndCellValue;
              firstRowAndCellText[response.summary[i].measure + "_rel"] =
                response.data.slice(-1)[0].measuresRel[i] == -1
                  ? "n/a"
                  : Helpers.formatNumberWithThousandSeparator(response.data.slice(-1)[0].measuresRel[i]).toString().replace('.', ',');
              let secondRowAndFirstCellValue =
                response.summary[i].average_frequency == -1
                  ? "n/a"
                  : Helpers.formatNumberWithThousandSeparator(response.summary[i].average_frequency).toString().replace('.', ',')
              secondRowAndFirstCellText[response.summary[i].measure] = secondRowAndFirstCellValue.toString().replace('.', ',');
              secondRowAndFirstCellText[
                response.summary[i].measure + "_rel"
              ] = secondRowAndFirstCellValue;
              let universeSizeValue = Helpers.formatNumberWithThousandSeparator(response.summary[i].universe_size).toString().replace('.', ',');
              universeSize[response.summary[i].measure] = Helpers.formatNumberWithThousandSeparator(universeSizeValue);
              universeSize[
                response.summary[i].measure + "_rel"
              ] = universeSizeValue;

              emptyRow[response.summary[i].measure] = "";
              emptyRow[response.summary[i].measure + "_rel"] = "";
            }

            context.commit("setItems", [...context.getters.items, firstRowAndCellText]);
            context.commit("setItems", [...context.getters.items, secondRowAndFirstCellText]);
            context.commit("setItems", [
              ...context.getters.items,
              universeSize
            ]);
            context.commit("setItems", [...context.getters.items, emptyRow]);
            context.commit("setItems", [...context.getters.items, emptyRow]);

            const fieldsAbs = [...context.getters.fieldsAbs];
            const fieldsRel = [...context.getters.fieldsRel];

            for (let i = 0; i < response.data.length; i++) {
              for (let j = 0; j < fieldsAbs.length; j++) {
                if (fieldsAbs[j].key !== "date_key") {
                  if (!response.data[i][fieldsAbs[j].key]) {
                    response.data[i][fieldsAbs[j].key] =
                      response.data[i].measures[j - 1] == -1
                        ? "n/a"
                        : Helpers.formatNumberWithThousandSeparator(response.data[i].measures[j - 1]).toString().replace('.', ',');
                  }
                }
              }

              for (let j = 0; j < fieldsRel.length; j++) {
                if (fieldsRel[j].key !== "date_key") {
                  if (!response.data[i][fieldsRel[j].key]) {
                    let measureRelValue = response.data[i].measuresRel[j - 1];
                    if (measureRelValue % 1 == 0)
                      measureRelValue = measureRelValue.toFixed(1);
                    response.data[i][fieldsRel[j].key] =
                      measureRelValue == -1 ? "n/a" : Helpers.formatNumberWithThousandSeparator(measureRelValue).toString().replace('.', ',');
                  }
                }
              }
            }
            context.commit("setFieldsAbs", fieldsAbs);
            context.commit("setItems", [
              ...context.getters.items,
              ...response.data
            ]);
          }
          context.commit("setLoading", false);
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            console.warn('Request canceled:', error.message); // Log cancellation
          } else {
          context.commit("setShowToastError", true);
          context.commit("setLoading", false);
          }
        });
    }
  }
};
